// Combined function
export const hasSpecialCharacters = (input) => {
    return hasSQLInjection(input) || hasXSS(input);
  };
  // SQL Injection detection function
export const hasSQLInjection = (input) => {
    const sqlInjectionRegex = /\b(SELECT\s+.*\s+FROM|INSERT\s+INTO\s+.*\s+VALUES|UPDATE\s+.*\s+SET|DELETE\s+FROM|DROP\s+TABLE|TRUNCATE\s+TABLE|ALTER\s+TABLE|CREATE\s+TABLE|REPLACE\s+INTO|RENAME\s+TABLE|GRANT\s+.*\s+TO|REVOKE\s+.*\s+FROM|DECLARE\s+@|EXEC\s+.*|UNION\s+SELECT|--|;|'|=|OR\s+\d+\s*=\s*\d+|AND\s+\d+\s*=\s*\d+)\b/i;
    return sqlInjectionRegex.test(input);
  };
  // XSS detection function
export const hasXSS = (input) => {
    const xssRegex = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>|alert\(|prompt\(|confirm\(|eval\(|javascript:|<[^>]+on\w+=["'][^"']*["']|<[^>]+style=["'][^"']*expression\([^"']*\)["']/gi;
    return xssRegex.test(input);
  };
  export const excludeKeysForText=["<",">","/","?","!"];

export const hasSpecialCharactersWithRegex = (input) => {
  // Define a regular expression pattern to match special characters, excluding '-' and '_'
  const regex = /[!@#$%^&*()+=\[\]{};'"\\|,.<>\/?~]/;

  // Test if the input string matches the regex pattern
  return regex.test(input);
};
export const preventUserToAddSymbol = (evt) => {
  if ((hasSpecialCharactersWithRegex(evt?.key))) {
    evt.preventDefault();
  }
};

// Function to format rows as key-value pairs with primaryTheme as the key and focus as the value
export const formatRows = (rows) => {
  return rows.map(({ primaryTheme, focus }) => ({
    key: primaryTheme, // Set key as primaryTheme
    value: focus, // Set value as focus
  }));
};